module.exports = [
    {
        name: "mocha-js",
        type: "js",
        version: "5.2.0",
        cdn: "https://cdn.rawgit.com/mochajs/mocha/$VERSION/mocha.js",
        bowerPath: "mocha/mocha.js",
        npmPath: "mocha/mocha.js"
    },
    {
        name: "mocha-css",
        type: "css",
        version: "5.2.0",
        cdn: "https://cdn.rawgit.com/mochajs/mocha/$VERSION/mocha.css",
        bowerPath: "mocha/mocha.css",
        npmPath: "mocha/mocha.css"
    },
    {
        name: "chai",
        type: "js",
        version: "4.1.2",
        cdn: "https://cdnjs.cloudflare.com/ajax/libs/chai/$VERSION/chai.js",
        bowerPath: "chai/chai.js",
        npmPath: "chai/chai.js"
    }
] ;